// src/components/QrCode.js
import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import { colors, radii } from "../styles/designTokens";

/**
 * Renders `value` (a URL) as a scannable QR code. Mainly for the
 * connect-link "share in person" flow, as a fallback for devices where
 * the native Web Share sheet isn't available (most desktop/laptop
 * browsers) - showing this on a screen and having the other person scan
 * it with their phone camera works everywhere a share sheet doesn't.
 */
const QrCode = ({ value, size = 180 }) => {
  const [dataUrl, setDataUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!value) return;
    QRCode.toDataURL(value, { width: size * 2, margin: 1, color: { dark: colors.ink, light: "#ffffff" } })
      .then((url) => { if (!cancelled) setDataUrl(url); })
      .catch((err) => {
        console.error("QrCode › generate error:", err);
        if (!cancelled) setError(true);
      });
    return () => { cancelled = true; };
  }, [value, size]);

  if (error) return null;

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: radii.sm,
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
        boxSizing: "border-box",
      }}
    >
      {dataUrl ? (
        <img src={dataUrl} alt="QR code to connect" width={size - 20} height={size - 20} />
      ) : (
        <div style={{ width: size - 20, height: size - 20, background: colors.surfaceMuted, borderRadius: radii.sm }} />
      )}
    </div>
  );
};

export default QrCode;
